
import React from 'react';
import { connect } from 'react-redux';

import Navbar from '../../../../../_components/common/Navbar';
import SideNavBar from '../../../../../_components/common/SideNavBar'
import { orgAdminAreaData, AnalyzeData } from '../../../OrgAdminArea/SidebarData'
import { Link, NavLink } from 'react-router-dom'
import AnalysisNavBar from '../../../../../_components/common/AnalysisNavBar'
import DynamicGradientTables from '../../../../../_components/common/DynamicGradientTables'
import ModularTooltip from '../../../../../_components/common/ModularTooltip'
import './index.css'
import { Collapse, Button, CardBody, Card } from 'reactstrap';
import CompetencyGraph from '../../../../../_components/common/CompetencyGraph';
import { saveModulePermissionsAction, orgAdminAction, saveTeamDetailsAction, analyseActions, superAdminAction } from '../../../../../_actions';
import { competencyListAction } from '../../../../../_actions/Analyze/competencyList.action'
import { competencyAction } from '../../../../../_actions/Analyze/competency.action'
import dataFormater from '../../dataFormater';

import CircularButtonGroup from "../../../../../_components/common/CircularButtonGroup";


import mostCompetentTitle from '../../../../../images/mostCompetentTitle.png';

import compLogo from '../../../../../images/competencylogoback.png';
import leftArrow from '../../../../../images/leftArrow.png'
import home from '../../../../../images/home.png'
import rightArrow from '../../../../../images/rightArrow.png'

class Competency extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            teamName: '',
            teamId: '',
            mode: 'filter_non',
            getPaUserPermissionListResponse: '',
            graph_arr: [],
            view_detailed_comparison: false,
            navData: [],
            selectedComp: [],
            select_data: [
                {
                    name: 'Biase fo rAction',
                    id: 1,
                },
                {
                    name: 'Org Team 2',
                    id: 2,
                },
                {
                    name: 'Org Team 3',
                    id: 3,
                },
            ],
            competencyData: [],
            checkboxData: [],
            checkboxDataLoader: true,

            class_name: {
                main_container: 'col-6 px-0',
                container: {
                    container: "d-flex flex-column w-100 p-1",
                    style: {
                        margin: 1
                    }
                },
                header_container: {
                    header_container: 'w-100 py-3 mb-1',
                    style: {
                        paddingLeft: 40,
                    }
                },
                header_container_non_routable: {
                    header_container_non_routable: 'd-flex flex-column text-white',
                    header_container_non_routable_title: 'font-weight-bold',
                    header_container_non_routable_optional: 'font-italic',
                },
                child_container: {
                    child_container: "d-flex flex-column w-100 px-0",
                    style: {
                        margin: 0
                    }
                },
                child_content_container: {
                    child_content_container: 'd-flex flex-column text-dark text-center mb-1 py-2',
                    child_content_container_header: 'font-weight-bold pt-1',
                    child_content_container_desc: 'font-italic py-1',
                    child_content_container_footer: 'font-weight-bold font-italic py-1',
                }
            },
            class_name1: {
                main_container: 'col-6 px-0',
                container: {
                    container: "d-flex flex-column w-100 p-1",
                    style: {
                        margin: 1
                    }
                },
                header_container: {
                    header_container: 'w-100 py-3 mb-1',
                    style: {
                        paddingLeft: 50,
                    }
                },
                header_container_non_routable: {
                    header_container_non_routable: 'd-flex flex-column text-white',
                    header_container_non_routable_title: 'font-weight-bold',
                    header_container_non_routable_optional: 'font-italic',
                },
                child_container: {
                    child_container: "d-flex flex-column w-100 px-0",
                    style: {
                        margin: 0
                    }
                },
                child_content_container: {
                    child_content_container: 'd-flex flex-column text-dark mb-1 text-center competency-temp',
                    child_content_container_header: 'font-weight-bold py-1',
                    child_content_container_desc: '',
                    child_content_container_footer: '',
                }
            },
            class_name_2: {
                main_container: 'col-6 px-0',
                container: {
                    container: "d-flex flex-column w-100 px-1",
                    style: {
                        margin: 1
                    }
                },
                header_container: {
                    header_container: 'w-100 mb-1',
                    style: {
                        paddingLeft: 40,
                    }
                },
                header_container_non_routable: {
                    header_container_non_routable: 'd-flex flex-column text-white',
                    header_container_non_routable_title: 'font-weight-bold',
                    header_container_non_routable_optional: 'font-italic',
                },
                child_container: {
                    child_container: "d-flex flex-column w-100 px-0",
                    style: {
                        margin: 0
                    }
                },
                child_content_container: {
                    child_content_container: 'd-flex flex-column text-dark text-center mb-1 py-2',
                    child_content_container_header: 'font-weight-bold pt-1',
                    child_content_container_desc: 'font-italic py-1',
                    child_content_container_footer: 'font-weight-bold font-italic py-1',
                }
            },
            class_name1_2: {
                main_container: 'col-6 px-0',
                container: {
                    container: "d-flex flex-column w-100 px-1",
                    style: {
                        margin: 1
                    }
                },
                header_container: {
                    header_container: 'w-100 mb-1',
                    style: {
                        paddingLeft: 50,
                    }
                },
                header_container_non_routable: {
                    header_container_non_routable: 'd-flex flex-column text-white',
                    header_container_non_routable_title: 'font-weight-bold',
                    header_container_non_routable_optional: 'font-italic',
                },
                child_container: {
                    child_container: "d-flex flex-column w-100 px-0",
                    style: {
                        margin: 0
                    }
                },
                child_content_container: {
                    child_content_container: 'd-flex flex-column text-dark mb-1 text-center competency-temp',
                    child_content_container_header: 'font-weight-bold py-1',
                    child_content_container_desc: '',
                    child_content_container_footer: '',
                }
            },
            data: [],
            data1: [],
            competency_length: [],
            competency_all_data: {},
            multi_competency_length: [],
            competency_title: '',
            competency_avg: null,
            competency_avg_percent: null,
            currentLevelName: [],
            back_track: false,
            filterData: null,

            ImprovementTooltip: {},
            openImprovementTooltip: false,

            collapseViewAllCompetent: false,

            competencyMetricList: {
                competency: [],
                value: []
            },
            traceable_value: null,
            selected_route_parameter_copy: null,
            dynamicTableImprovementAreas: [],
            currentCategoryOnRoute: 2,
            selectedRouteId: 0
        }
        this.toggleShowViewAllCompetent = this.toggleShowViewAllCompetent.bind(this)
        this.renderCustomComponent = this.renderCustomComponent.bind(this)
        this.callBack = this.callBack.bind(this)
    }

    componentDidUpdate(prevProp, prevState) {


        if(prevProp.competencyListDataResonse !== this.props.competencyListDataResonse) {
            if(this.props.competencyListDataResonse !== '') {
                let competencyMetricList = this.state.competencyMetricList;
                // response_get_metric_list.data.competency_metrices.map(metrics => {
                //     if(metrics.competency_type === 'Value') {
                //         competencyMetricList.value.push(metrics)
                //     }else if(metrics.competency_type === 'Competency') {
                //         competencyMetricList.competency.push(metrics)
                //     }
                // })
                competencyMetricList.value = this.props.competencyListDataResonse.data.organisation_competency_metrics.filter(metric => metric.assessment_organisation_competency__competency_type__competency_name === "Value").concat(this.props.competencyListDataResonse.data.default_competency_metrics.filter(metric => metric.competency_metric__competency_type__competency_name === "Value"))
                competencyMetricList.competency = this.props.competencyListDataResonse.data.organisation_competency_metrics.filter(metric => metric.assessment_organisation_competency__competency_type__competency_name === "Competency").concat(this.props.competencyListDataResonse.data.default_competency_metrics.filter(metric => metric.competency_metric__competency_type__competency_name === "Competency"))
                this.setState({
                    competencyMetricList
                }, () => {
                    this.setState({checkboxData: dataFormater(this.props,this.state.competencyMetricList,'competency_list'), checkboxDataLoader: false})
                })
            }
        }
        
        if(prevState.competency_length !== this.state.competency_length) {
            if(this.state.competency_length.length) {
                var colorCombinationLevels = []

                if(this.state.competency_length[0].levels.length) {
                    this.state.competency_length[0].levels.map((level, pos) => {
                        let colors = ['#90EE90', '#228B22', '#006400', '#DC143C', '#FF4500', '#800000', '#00BFFF', '#1E90FF', '#4B0082', '#FFFF00', '#808000']
                        let totalPush = level.end_value - level.start_value
                        for (let i = 0; i < totalPush; i++) {
                            colorCombinationLevels.push({
                                color: colors[pos]
                            })
                        }
                    })
                }else {
                    let colors = ['#90EE90', '#228B22', '#006400', '#DC143C', '#FF4500', '#800000', '#00BFFF', '#1E90FF', '#4B0082', '#FFFF00', '#808000']
                    for (let i = 0; i < 10; i++) {
                        colorCombinationLevels.push({
                            color: colors[6]
                        })
                    }
                }

                this.setState({
                    graph_arr: colorCombinationLevels,
                    currentLevelName: `(${this.state.competency_length[0].currentLevelName})`
                })
            }else {
                var colorCombinationLevels = []

                for (let i = 0; i < 10; i++) {
                    colorCombinationLevels.push({
                        color: '#90EE90'
                    })
                }

                this.setState({
                    graph_arr: colorCombinationLevels,
                })
            }
        }
        if(prevProp.saveAssesorGroupListResponse !== this.props.saveAssesorGroupListResponse) {
            if(this.props.saveAssesorGroupListResponse !== '') {
                this.setState({filterData: this.props.saveAssesorGroupListResponse})
            }
        }

        if(prevProp.competencyDataResonse !== this.props.competencyDataResonse) {
            if(this.props.competencyDataResonse !== '') {
                this.setState({competency_all_data: this.props.competencyDataResonse.data, competency_length: dataFormater(this.props,this.props.competencyDataResonse.data,'competency_data_each',this.state.checkboxData)},() => {
                    if(this.state.competency_length.length == 1) {
                        var competency_avg = this.state.competency_length[0].competency_avg
                        var competency_avg_percent = (parseFloat(competency_avg) * 100) / 10

                        let attributeNameFirst = ''
                        let attributeNameSecond = ''

                        const FirstArea = this.state.competency_length[0].data.map(content => {
                            const Areas = [content.child_content[0]]
                            if(content.child_content[0]) {
                                attributeNameFirst = content.child_content[0].attribute_name
                            }
                            return {
                                ...content,
                                child_content: Areas
                            }
                        })

                        const SecondArea = this.state.competency_length[0].data.map(content => {
                            const Areas = [content.child_content[1]]
                            if(content.child_content[1]) {
                                attributeNameSecond = content.child_content[1].attribute_name
                            }
                            return {
                                // ...content,
                                header_background_image: '',
                                header_sub_text: '',
                                header_text: '',
                                link: '',
                                child_content: Areas
                            }
                        })


                        const firstMostComp = this.state.competency_length[0].data1.map(content => {
                            const Areas = content.child_content.filter(child => {
                                if(attributeNameFirst.length) {
                                    return child.attribute_name === attributeNameFirst
                                }
                                attributeNameFirst = child.attribute_name
                                return true
                            })

                            const hasArea = FirstArea.some(area => {
                                if(area.child_content.length === 1) {
                                    if(area.child_content[0] === undefined) {
                                        return false
                                    }else {
                                        return true
                                    }
                                }else {
                                    return true
                                }
                            })

                            return {
                                ...content,
                                child_content: Areas.length ? Areas : hasArea ? [{
                                    attribute_name: "Openness",
                                    child_content: "There are no individuals with adequate competence in this area",
                                    child_content_background_color: "",
                                    child_footer: "",
                                    child_header: "",
                                    link: ""
                                }] : []
                            }
                        })
                        

                        const SecondMostComp = this.state.competency_length[0].data1.map(content => {
                            const Areas = content.child_content.filter(child => {
                                return attributeNameSecond === child.attribute_name
                            })

                            const hasArea = SecondArea.some(area => {
                                if(area.child_content.length === 1) {
                                    if(area.child_content[0] === undefined) {
                                        return false
                                    }else {
                                        return true
                                    }
                                }else {
                                    return true
                                }
                            })

                            return {
                                // ...content,
                                header_background_image: '',
                                header_sub_text: '',
                                header_text: '',
                                link: '',
                                child_content: Areas.length && hasArea ? Areas : hasArea ? [{
                                    attribute_name: "Openness",
                                    child_content: "There are no individuals with adequate competence in this area",
                                    child_content_background_color: "",
                                    child_footer: "",
                                    child_header: "",
                                    link: ""
                                }] : []
                            }
                        })


                        const dynamicFirstImproveRow = {
                            area: FirstArea,
                            comp: firstMostComp
                        }

                        const dynamicSecondImproveRow = {
                            area: SecondArea,
                            comp: SecondMostComp
                        }

                        const dynamicImproveRow = [ dynamicFirstImproveRow, dynamicSecondImproveRow ]
                        
                        this.setState({ data: this.state.competency_length[0].data,data1: this.state.competency_length[0].data1, dynamicTableImprovementAreas: dynamicImproveRow , view_detailed_comparison: false,competency_title:this.state.competency_length[0].competency_title,competency_avg_percent: competency_avg_percent,competency_avg:competency_avg})
                    }
                    else {
                        var reformed_data = []
                        var multi_competency_avg = 0
                        var count = 0
                        var multi_competency_title = ''
                        this.state.competency_length.map((val, i) => {
                            multi_competency_avg = multi_competency_avg + val.competency_avg
                            multi_competency_title = i == 0 ? multi_competency_title + val.competency_title : multi_competency_title + ', ' + val.competency_title
                            reformed_data.push({
                                title: val.competency_title,
                                title_value: val.competency_avg,
                                title_id: val.competency_id,
                                competency_arr_for_each: [val]
                            })
                            count++
                        })

                        

                        multi_competency_avg = multi_competency_avg / count
                        var multi_competency_avg_percent = (parseFloat(multi_competency_avg) * 100) / 10
                        this.setState({ multi_competency_length: this.state.competency_length,competencyData: reformed_data,competency_avg: multi_competency_avg,competency_avg_percent: multi_competency_avg_percent,competency_title: multi_competency_title})

                    }
                })
            }
        }
        if(prevProp.headPerLoadingResonse !== this.props.headPerLoadingResonse) {
            if(this.props.headPerLoadingResonse !== '') {
                const temp = []
                if(localStorage.getItem("is_pa_user") == "true") {
                    temp.push({
                        navName: "Analyze",
                        link: `/organisation/${this.props.match.params.id}/user`
                    })
                }
                if(localStorage.getItem("is_org_admin") == "true") {
                    temp.push({
                        navName: "Org Admin Area",
                        link: `/organisation/${this.props.match.params.id}/org-admin`
                    })
                }
                if(localStorage.getItem("is_success") == "true") {
                    temp.push({
                        navName: "Super Admin Area",
                        link: `/organisation/${this.props.match.params.id}/super-admin`
                    })
                }
                this.setState({navData: temp})
            }
        }

        if(prevProp.saveAssesorIdsResponse !== this.props.saveAssesorIdsResponse) {
            if(this.props.saveAssesorIdsResponse !== '') {
                var inter_arr = []
                if(this.state.selectedComp.length) {
                    inter_arr = this.state.selectedComp
                }else {
                    this.state.checkboxData.map((obj) => {
                        if(obj.disabled == false) {
                            obj.data.map(ob => {
                                if(ob.isChecked == true) {
                                    inter_arr.push(ob.id)
                                }
                            })
                        }
                    })
                }

                if(inter_arr.length) {
                    this.setState({
                        selectedComp: inter_arr
                    })
                    var temp = this.state.checkboxData
                    
                    var post_ob = {}
                    temp.map((obj) => {
                        if(obj.disabled == false) {
                            var inter_arr = this.state.selectedComp.length ? this.state.selectedComp : [];

                            !inter_arr.length ? 
                                obj.data.map(ob => {
                                    if(ob.isChecked == true) {
                                        inter_arr.push(ob.id)
                                    }
                                })
                            :
                                null

                            post_ob = {
                                "team_assessment_id":this.props.saveAssesorIdsResponse.assessmentIds, 
                                "competency_ids":inter_arr,
                                "type": obj.heading, 
                                "relation_group_ids":this.props.saveAssesorIdsResponse.assessorIds,
                                "organisation": +this.props.match.params.id
                            }
                        }
                    })
                    this.props.dispatch(competencyAction.competencyDataAction(post_ob, (competencyData_response) => {
                        if(this.state.selected_route_parameter_copy !== null) {
                            
                            const competencyArr = dataFormater(this.props, competencyData_response.data,'competency_data_each',this.state.checkboxData)

                            let reformed_data = []
                            
                            competencyArr.map((val, i) => {
                                reformed_data.push({
                                    title: val.competency_title,
                                    title_value: val.competency_avg,
                                    title_id: val.competency_id,
                                    competency_arr_for_each: [val]
                                })
                            })

                            this.onActionInvoked(this.state.selected_route_parameter_copy, reformed_data[this.state.selected_route_parameter_copy])
                        }
                    }))
                    this.setState({mode: 'filter_applied'})
                }
            }
        }
    }

    componentDidMount() {

        this.props.dispatch(saveModulePermissionsAction.requestModulePermissionsHandler())
        if (this.props.saveModulePermissionsResponse !== '' ) {
            this.props.saveModulePermissionsResponse.filter(
                (data, i) => {
                    if (data.module_list__module_name === 'Competency') {
                        return data
                    }
                }
            ).length === 0 &&
                this.props.history.push(`/organisation/${this.props.match.params.id}/user/dashboard`)
        }

        //filter data
        if(this.props.saveAssesorGroupListResponse !== '') {
            this.setState({filterData: this.props.saveAssesorGroupListResponse})
        }

        //Header permissions
        const temp = []
        if(localStorage.getItem("is_pa_user") == "true") {
            temp.push({
                navName: "Analyze",
                link: `/organisation/${this.props.match.params.id}/user`
            })
        }
        if(localStorage.getItem("is_org_admin") == "true") {
            temp.push({
                navName: "Org Admin Area",
                link: `/organisation/${this.props.match.params.id}/org-admin`
            })
        }
        if(localStorage.getItem("is_success") == "true") {
            temp.push({
                navName: "Super Admin Area",
                link: `/organisation/${this.props.match.params.id}/super-admin`
            })
        }

        if(this.props.competencyListDataResonse !== '') {
            let competencyMetricList = this.state.competencyMetricList;
            // response_get_metric_list.data.competency_metrices.map(metrics => {
            //     if(metrics.competency_type === 'Value') {
            //         competencyMetricList.value.push(metrics)
            //     }else if(metrics.competency_type === 'Competency') {
            //         competencyMetricList.competency.push(metrics)
            //     }
            // })
            competencyMetricList.value = this.props.competencyListDataResonse.data.organisation_competency_metrics.filter(metric => metric.assessment_organisation_competency__competency_type__competency_name === "Value").concat(this.props.competencyListDataResonse.data.default_competency_metrics.filter(metric => metric.competency_metric__competency_type__competency_name === "Value"))
            competencyMetricList.competency = this.props.competencyListDataResonse.data.organisation_competency_metrics.filter(metric => metric.assessment_organisation_competency__competency_type__competency_name === "Competency").concat(this.props.competencyListDataResonse.data.default_competency_metrics.filter(metric => metric.competency_metric__competency_type__competency_name === "Competency"))
            this.setState({
                competencyMetricList
            }, () => {
                this.setState({checkboxData: dataFormater(this.props,this.state.competencyMetricList,'competency_list'), checkboxDataLoader: false})
            })
    
        }

        
        this.setState({navData: temp})


    }

    // onChangeTeam = (teamDetails) => {
    //     const team = {
    //         "team_id": teamDetails.analytics_team_id
    //     }
    //     this.props.dispatch(analyseActions.getAssessorGroupsHandler(team, () => {
    //         this.props.dispatch(analyseActions.saveAssessorGroups(this.props.assessorGroupsResponse))
    //     }))
    // }

    // stateHandler(key) {
    //     this.setState({ view_detailed_comparison: key })
    // }

    onActionInvoked = (key, val) => {
        this.setState({ 
            selected_route_parameter: key,
            Tooltip: !this.state.Tooltip, 
            traceable_value: val,
            selected_route_parameter_copy: key,
            competency_length: val.competency_arr_for_each,
            back_track:true,
        },() => {
            var competency_avg = this.state.competency_length[0].competency_avg
            var competency_avg_percent = (parseFloat(competency_avg) * 100) / 10

            let attributeNameFirst = ''
            let attributeNameSecond = ''

            const FirstArea = this.state.competency_length[0].data.map(content => {
                const Areas = [content.child_content[0]]
                if(content.child_content[0]) {
                    attributeNameFirst = content.child_content[0].attribute_name
                }
                return {
                    ...content,
                    child_content: Areas
                }
            })

            const SecondArea = this.state.competency_length[0].data.map(content => {
                const Areas = [content.child_content[1]]
                if(content.child_content[1]) {
                    attributeNameSecond = content.child_content[1].attribute_name
                }
                return {
                    // ...content,
                    header_background_image: '',
                    header_sub_text: '',
                    header_text: '',
                    link: '',
                    child_content: Areas
                }
            })


            const firstMostComp = this.state.competency_length[0].data1.map(content => {
                const Areas = content.child_content.filter(child => {
                    if(attributeNameFirst.length) {
                        return child.attribute_name === attributeNameFirst
                    }
                    attributeNameFirst = child.attribute_name
                    return true
                })

                const hasArea = FirstArea.some(area => {
                    if(area.child_content.length === 1) {
                        if(area.child_content[0] === undefined) {
                            return false
                        }else {
                            return true
                        }
                    }else {
                        return true
                    }
                })

                return {
                    ...content,
                    child_content: Areas.length && hasArea ? Areas : hasArea ? [{
                        attribute_name: "Openness",
                        child_content: "There are no individuals with adequate competence in this area",
                        child_content_background_color: "",
                        child_footer: "",
                        child_header: "",
                        link: ""
                    }] : []
                }
            })

            const SecondMostComp = this.state.competency_length[0].data1.map(content => {
                const Areas = content.child_content.filter(child => {
                    return attributeNameSecond === child.attribute_name
                })

                const hasArea = SecondArea.some(area => {
                    if(area.child_content.length === 1) {
                        if(area.child_content[0] === undefined) {
                            return false
                        }else {
                            return true
                        }
                    }else {
                        return true
                    }
                })

                return {
                    // ...content,
                    header_background_image: '',
                    header_sub_text: '',
                    header_text: '',
                    link: '',
                    child_content: Areas.length && hasArea ? Areas : hasArea ? [{
                        attribute_name: "Openness",
                        child_content: "There are no individuals with adequate competence in this area",
                        child_content_background_color: "",
                        child_footer: "",
                        child_header: "",
                        link: ""
                    }] : []
                }
            })

            const dynamicFirstImproveRow = {
                area: FirstArea,
                comp: firstMostComp
            }

            const dynamicSecondImproveRow = {
                area: SecondArea,
                comp: SecondMostComp
            }

            const dynamicImproveRow = [ dynamicFirstImproveRow, dynamicSecondImproveRow ]
            
            this.setState({dynamicTableImprovementAreas: dynamicImproveRow, data: this.state.competency_length[0].data,data1: this.state.competency_length[0].data1,view_detailed_comparison: false,competency_title:this.state.competency_length[0].competency_title,competency_avg_percent: competency_avg_percent,competency_avg:competency_avg})
        })
    }

    onClickCheckbox = (event, id, name) => {
        let checkboxData = this.state.checkboxData;
        let tableCount = 0;
        for (let i = 0; i < checkboxData.length; i++) {
            if (checkboxData[i].name === name) {
                for (let j = 0; j < checkboxData[i].data.length; j++) {
                    if (checkboxData[i].data[j].id === id) {
                        checkboxData[i].data[j].isChecked = event.target.checked
                    }
                    if (event.target.checked === true && checkboxData[i].data[j].id === id) {
                        checkboxData[i].count = checkboxData[i].count + 1;
                    }
                    if (event.target.checked === false && checkboxData[i].data[j].id === id) {
                        checkboxData[i].count = checkboxData[i].count - 1;
                    }
                }
            }
            if (checkboxData[i].count > 0) {
                tableCount = tableCount + 1;
            }
        }
        for (let i = 0; i < checkboxData.length; i++) {
            if (checkboxData[i].count == 0 && tableCount > 0) {
                checkboxData[i].disabled = true
            }
            if (tableCount === 0) {
                checkboxData[i].disabled = false
            }
        }
        this.setState({ checkboxData: checkboxData, checkboxDataLoader: false })
    }

    applyFilters = () => {
        var temp = this.state.checkboxData
        
        var post_ob = {}
        temp.map((obj) => {
            if(obj.disabled == false) {
                var inter_arr = []
                obj.data.map(ob => {
                    if(ob.isChecked == true) {
                        inter_arr.push(ob.id)
                    }
                })

                post_ob = {
                    "team_assessment_id":this.props.saveAssesorIdsResponse.assessmentIds, 
                    "competency_ids":inter_arr, 
                    "type": obj.heading, 
                    "relation_group_ids":this.props.saveAssesorIdsResponse.assessorIds,
                    "organisation": +this.props.match.params.id
                }
            }
        })
        this.props.dispatch(competencyAction.competencyDataAction(post_ob))
        this.setState({mode: 'filter_applied'})
    }

    // renderReusables(data) {
    //     return (
    //         <div className="d-flex flex-row align-items-center align-self-center mx-0">
    //             <div className="p-2" style={{ backgroundColor: "#f8e9e7", width: 100 }}>
    //                 <h6 className="mb-0 text-center">{data.name}</h6>
    //             </div>
    //         </div>
    //     )
    // }

    selectMultipleButtonAction = () => {
        this.setState({multi_competency_length: [], mode: 'filter_non',data: [],data1: [],competency_title:'',competency_avg_percent: null,competency_avg:null,competency_length: [],back_track: false})
    }

    backTrack = () => {
        this.setState({
            traceable_value: null,
            selected_route_parameter_copy: null,
            back_track:false,
            competency_length: this.state.multi_competency_length,
            selected_route_parameter: null,
            data:[],
            data1:[],
            dynamicTableImprovementAreas: [],
        }, () => {
            var reformed_data = []
            var multi_competency_avg = 0
            var count = 0
            var multi_competency_title = ''
            this.state.competency_length.map((val, i) => {
                multi_competency_avg = multi_competency_avg + val.competency_avg
                multi_competency_title = i == 0 ? multi_competency_title + val.competency_title : multi_competency_title + ', ' + val.competency_title
                reformed_data.push({
                    title: val.competency_title,
                    title_value: val.competency_avg,
                    title_id: val.competency_id,
                    competency_arr_for_each: [val]
                })
                count++
            })
            multi_competency_avg = multi_competency_avg / count
            var multi_competency_avg_percent = (parseFloat(multi_competency_avg) * 100) / 10
            this.setState({multi_competency_length: this.state.competency_length,competencyData: reformed_data,competency_avg: multi_competency_avg,competency_avg_percent: multi_competency_avg_percent,competency_title: multi_competency_title})
        })
    }

    renderCustomComponent() {
        const data = this.state.competency_length[0].attributes.sort(function(a, b) {
            return b.average_score - a.average_score;
        });
        return (
            <div className="d-flex flex-column">
               {
                    data.length ?
                        data.map((val, key) => {
                                return (
                                    <div key={key} className="d-flex flex-row justify-content-between" style={{fontSize: 12}}>
                                        <p className="mb-0 font-italic">
                                            {val.name}
                                        </p>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <p className="mb-0 font-italic pr-1">
                                                {val.average_score}
                                            </p>
                                            <i class="fas  fa-caret-right text-right pl-1" style={{color: 'grey'}}></i>
                                        </div>
                                    </div>
                                )
                        })
                    :
                        <p className="mb-0 font-italic text-center">
                            No Team Members
                        </p>
               }
            </div>
        )
    }

    callBack() {
        this.setState({ modularToolTip: !this.state.modularToolTip })
    }

    toggleShowViewAllCompetent() {
        this.setState({
            collapseViewAllCompetent: !this.state.collapseViewAllCompetent
        })
    }



    renderAlluserAvg() {
        var unsortedData = []

        let arrayWithAttrMembers = {}

        this.state.competency_all_data.individual.map((ob) => {

            ob.attributes.map(attr => {
                // const currentName = attr.name
                const combinedValue = attr.attributes.map(attr => attr.average_score).reduce((total, acc) => {
                    return total + acc
                })

                const avgValue = combinedValue / attr.attributes.length

                // arrayWithAttrMembers.push({
                //     name: currentName,
                //     totalValue
                // })

                if(arrayWithAttrMembers[attr.email]) {
                    arrayWithAttrMembers[attr.email].push({
                        ...attr,
                        lengthArr: attr.attributes.length,
                        combinedValue,
                        avgValue
                    })
                }else {
                    arrayWithAttrMembers[attr.email] = [{
                        ...attr,
                        lengthArr: attr.attributes.length,
                        combinedValue,
                        avgValue
                    }]
                }
            })


        })

        const totalCompetentMembers = []


        for (const memberName in arrayWithAttrMembers) {
            if (arrayWithAttrMembers.hasOwnProperty(memberName)) {
                const element = arrayWithAttrMembers[memberName];
                const totalElem = element.map(elem => elem.avgValue).reduce((total, acc) => total + acc);
                let nameFromEmail = ''
                for (let i = 0; i < element.length; i++) {
                    const elem = element[i];
                    nameFromEmail = elem.name
                }
                totalCompetentMembers.push({
                    title: nameFromEmail ? nameFromEmail : memberName,
                    title_value: +(totalElem / element.length).toFixed(2),
                    total_value: totalElem,
                    lengthProp: element.length
                })
            }
        }


        // let most_competent_avg = []

        // this.state.competency_all_data.individual.map((ob) => {


        //     ob.development_plan_and_most_competent_of_indivisual.map((ob1) => {


        //         ob1.most_competent.map(ob2 => {

        //             most_competent_avg.push({ name: ob2.name, attribute_score: ob2.attribute_score })


        //             // unsortedData.push({title:ob2.child_header,title_value:ob2.attribute_score})
        //         })
        //     })
        // })

        // let prevName = ''
        // let most_avg_comp_obj = {
            
        // }

        // most_competent_avg.map(member => {
        //     if(prevName === member.name) {
        //         prevName = member.name
        //         most_avg_comp_obj[prevName].push(member)
        //     }else {
        //         prevName = member.name
        //         most_avg_comp_obj[prevName] = []
        //         most_avg_comp_obj[prevName].push(member)
        //     }
        // })

        // const average_score_unsorted = []

        // for (const memberName in most_avg_comp_obj) {
        //     if (most_avg_comp_obj.hasOwnProperty(memberName)) {
        //         const element = most_avg_comp_obj[memberName];
        //         const totalElem = element.map(elem => elem.attribute_score).reduce((total, acc) => total + acc);
        //         average_score_unsorted.push({
        //             title: memberName,
        //             title_value: +(totalElem / element.length).toFixed(2)
        //         })
        //     }
        // }
        
        const data = totalCompetentMembers.sort(function(a, b) {
            return b.title_value - a.title_value;
        }).filter(member => member.title_value >= 8.1)
        return(
            <div className="d-flex flex-column col-4" style={{ paddingTop: '1.3rem' }}>
                <div className="d-flex flex-column py-2" style={{paddingLeft: 40,backgroundImage: `url(${mostCompetentTitle})`}}>
                    <h5 className="mb-0 text-white">MOST COMPETENT</h5>
                    <h6 className="mb-0 text-white" style={{fontSize: 10}}>(People who can guid the team in these areas)</h6>
                </div>
                <div className="d-flex flex-column">
                    {
                        data.length <= 5 ?
                            data.map((obj, key) => {
                                return (
                                    <div key={key} className="d-flex flex-row text-left" style={{margin: 2}}>
                                        <div className="d-flex  col-9 p-1 pl-4 mr-1 competency-temp" style={{background:"linear-gradient(to right, #d3d9f1 , #b1cfd6)"}}>
                                            <p className="font-weight-bold mb-0" style={{fontSize: 12, wordBreak: 'break-all'}}>{obj.title}</p>
                                        </div>
                                        <div className="d-flex  col-3 p-1 mr-1 competency-temp" style={{background:"linear-gradient(to right, #d3d9f1 , #b1cfd6)"}}>
                                            <p className="font-weight-bold mb-0" style={{fontSize: 12}}>{obj.title_value}</p>
                                        </div>
                                    </div>
                                )
                            })
                        :
                            <React.Fragment>
                                <div style={{maxHeight: 400, overflowY: 'auto', overflowX: 'hidden'}}>
                                    {
                                        data.map((obj, key) => {
                                            if(key <= 5) {
                                                return (
                                                    <div key={key} className="d-flex flex-row text-left" style={{margin: 2}}>
                                                        <div className="d-flex  col-9 p-1 pl-4 mr-1 competency-temp" style={{background:"linear-gradient(to right, #d3d9f1 , #b1cfd6)"}}>
                                                            <p className="font-weight-bold mb-0" style={{fontSize: 12, wordBreak: 'break-all'}}>{obj.title}</p>
                                                        </div>
                                                        <div className="d-flex  col-3 p-1 mr-1 competency-temp" style={{background:"linear-gradient(to right, #d3d9f1 , #b1cfd6)"}}>
                                                            <p className="font-weight-bold mb-0" style={{fontSize: 12}}>{obj.title_value}</p>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        })
                                    }
                                    <Collapse isOpen={this.state.collapseViewAllCompetent}>
                                        <Card>
                                                {
                                                    data.map((obj, key) => {
                                                        if(key > 5) {
                                                            return (
                                                                <div key={key} className="d-flex flex-row text-left" style={{margin: 2}}>
                                                                    <div className="d-flex  col-9 p-1 pl-4 mr-1 competency-temp" style={{background:"linear-gradient(to right, #d3d9f1 , #b1cfd6)"}}>
                                                                        <p className="font-weight-bold mb-0" style={{fontSize: 12, wordBreak: 'break-all'}}>{obj.title}</p>
                                                                    </div>
                                                                    <div className="d-flex  col-3 p-1 mr-1 competency-temp" style={{background:"linear-gradient(to right, #d3d9f1 , #b1cfd6)"}}>
                                                                        <p className="font-weight-bold mb-0" style={{fontSize: 12}}>{obj.title_value}</p>
                                                                    </div>
                                                                </div>
                                                            )
                                                        }
                                                    })
                                                }
                                        </Card>
                                    </Collapse>
                                </div>
                                <Button color="primary" onClick={this.toggleShowViewAllCompetent} style={{ marginBottom: '1rem', padding: 0, background: '#666666' }}>{this.state.collapseViewAllCompetent ? 'View Top 5' : 'View All'}</Button>
                            </React.Fragment>
                    }
                </div>
            </div>
        )
    }

    renderApplyFilterButton() {
        var disabled = false
        this.state.checkboxData.map((obj,key) => {
            if(obj.disabled == true) {
                disabled = true
            }
        })
        if(disabled) {
            return (
                <div className="d-flex justify-content-center my-4" style={{cursor: 'pointer'}}>
                    <div className="py-1 px-4 bg-dark text-white" onClick={() => this.applyFilters()}>
                        <h6 className="mb-0">Apply</h6>
                    </div>
                </div>
            )
        }
    }

    openModularToolTipForImprovementIdeas(childContent, headerText) {
        this.setState({
            ImprovementTooltip: {
                childContent,
                headerText
            },
            openImprovementTooltip: !this.state.openImprovementTooltip
        })
    }


    popUpImprovement(review_question_text) {
        const popUpUiClassNames = {
            child_recomended_points_container: 'font-weight-bold font-size-12',
            child_recomended_points_header: 'font-weight-bold',
            child_recomended_points_list_container: 'child_recomended_points_list_container_adjust pad-x-0_4rem',
            child_recomended_points_list_items: 'font-italic',
        }

        let listData = []

        if(review_question_text) {
            const splitReview_question_text = review_question_text.split('- ')
            const mappedReview_question_text = splitReview_question_text.map(text => {
                return {value: text}
            })
            listData = [...mappedReview_question_text]
        }else {
            listData = [{
                value:'Goal or Target-setting'
            },{
                value:'Strategy Planning'
            },{
                value:'Project planning and execution'
            },{
                value:'Goal or Target-setting'
            },{
                value: 'One-to-one meetings'
            }]
        }

        return (
            <div className={`${popUpUiClassNames.child_recomended_points_container} mb-0`}>
                <p className={`${popUpUiClassNames.child_recomended_points_header} mb-0`}></p>
                <ul className={`${popUpUiClassNames.child_recomended_points_list_container} mb-0`}>
                    {
                        listData.map(listDataEach => {
                            return <li className={`${popUpUiClassNames.child_recomended_points_list_items} mb-0`} >{listDataEach.value}</li>
                        })
                    }
                </ul>
            </div>
        )
    }

    competencyValueDropDownOnChange(e) {
        const stringValueDropDown = e.target.value
        const valueDropDown = +e.target.value
        this.setState({
            modularToolTip: false
        }, () => {
            if(stringValueDropDown === 'goBack') {
                this.backTrack()
            }else {
                const competency_length_data =  dataFormater(this.props,this.state.competency_all_data,'competency_data_each',this.state.checkboxData)
                this.setState({
                    competency_length: competency_length_data
                }, () => {
                    this.state.competencyData.map((competencyDataEach, key) => {
                        if(competencyDataEach.title_id === valueDropDown) {
                            this.onActionInvoked(key, competencyDataEach)
                        }
                    })
                })
            }
        })
    }

    selectRoutes = (id) => {
        const competency_length_data =  dataFormater(this.props,this.state.competency_all_data,'competency_data_each',this.state.checkboxData)
        

        let currentCategoryOnRoute = 0

        let currentKey = 0;
        if (id === 1) {
            this.state.competencyData.map((val, key) => {
                if(this.state.selectedRouteId === key) {
                    if (key === 0) {
                        currentKey = this.state.competencyData.length - 1;
                    } else {
                        currentKey = key - 1;
                    }
                }
            });
        } else if (id === 3) {
            this.state.competencyData.map((val, key) => {
                if(this.state.selectedRouteId === key) {
                    if (key === this.state.competencyData.length - 1) {
                        currentKey = 0;
                    } else {
                        currentKey = key + 1;
                    }
                }
            });
        }else if(id === 2) {
            currentCategoryOnRoute = 2
        }

        this.setState({
            competency_length: competency_length_data,
            selectedRouteId: currentKey,
            currentCategoryOnRoute
        }, () => {
            this.state.competencyData.map((competencyDataEach, key) => {
                if(key === this.state.selectedRouteId) {
                    this.onActionInvoked(key, competencyDataEach)
                }
            })
            if(id === 2) {
                this.backTrack()
            }
        })
    }

    selectHomeRoutes = () => {
        this.setState({multi_competency_length: [], mode: 'filter_non',data: [],data1: [],competency_title:'',competency_avg_percent: null,competency_avg:null,competency_length: [],back_track: false})
    }

    routableSelects = () => {
        const redirectButtons = [
            {
                img: leftArrow,
                name: "Prev",
                id: 1,
                tooltip_id:1
            },{
                img: home,
                name: "Home",
                id: 2,
                tooltip_id:2
            },{
                img: rightArrow,
                name: "Next",
                id: 3,
                tooltip_id:3
            },
        ]
        return (
            <div className="d-flex">
                {
                    this.state.multi_competency_length.length > 1 && this.state.competency_length.length === 1 ?
                        <CircularButtonGroup
                            buttonGroupData={redirectButtons}
                            swotCatagory={this.state.currentCategoryOnRoute}
                            uncontrolledButton={true}
                            onClick={this.selectRoutes.bind(this)}
                            textAlign={"justify-content-start"}
                        />
                    :
                        null
                }
                <CircularButtonGroup
                    buttonGroupData={[
                        {
                            img: compLogo,
                            name: "Competency Home",
                            id: 10,
                            tooltip_id: 10
                        }
                    ]}
                    swotCatagory={false}
                    uncontrolledButton={true}
                    onClick={this.selectHomeRoutes.bind(this)}
                    textAlign={"justify-content-end"}
                />
                {/* <Button className="d-flex" style={{cursor: 'pointer', background: 'transparent' }} onClick={() => this.selectMultipleButtonAction()}>
                    <img className="compLogo" src={compLogo} width={100} alt="competency logo" />
                    <Tooltip placement="top" className="toolTipColor" isOpen={} target={`TooltipHome`} toggle={(e) => this.toggleTooltip('TooltipHome')} delay={{ show: 0, hide: 5 }}>
                        Home
                    </Tooltip>
                </Button> */}
            </div>
        )
    }

    renderPostFilter() {
        const arr = this.state.graph_arr
        const { select_data, view_detailed_comparison } = this.state





        if(this.state.competency_length.length == 1) {
            return (
                <React.Fragment key={this.state.competency_length}>
                    <div className="d-flex justify-content-around drop-down-container mb-3 mt-5">
                        {/* <div className="d-flex">
                            {
                                this.state.back_track?
                                <div className="d-flex" style={{cursor: 'pointer'}} onClick={() => this.backTrack()}>
                                    <i className="fas fa-arrow-left mb-0 pt-2 " ></i>
                                    <p className="mb-0 p-1 font-weight-bold">Back</p>
                                </div>:
                                <div>
                                </div>
                            }
                        </div>
                        <div className="d-flex justify-content-center">
                            <h6 className="d-flex justify-content-end align-items-center mb-0 px-2 ">Select Competency/Value</h6>
                            <select
                                className="drop-down"
                                onChange={(e) => this.competencyValueDropDownOnChange(e)}
                            >
                                <option value="goBack"></option>
                                {
                                    dataFormater(this.props,this.state.competency_all_data,'competency_data_each',this.state.checkboxData).map(competencyData => {
                                        if(competencyData.competency_id === this.state.competency_length[0].competency_id) {
                                            return <option value={competencyData.competency_id} selected disabled>{competencyData.competency_title}</option>
                                        }else {
                                            return <option value={competencyData.competency_id} >{competencyData.competency_title}</option>
                                        }
                                    })
                                }
                            </select>
                        </div> */}
                        
                        {/* <div className="d-flex" style={{cursor: 'pointer', }} onClick={() => this.selectMultipleButtonAction()}>
                            <p className="mb-0 p-1 font-weight-bold">Select Multiple</p>
                            <i className="fas fa-caret-right mb-0 pt-2 " style={{fontSize: '1rem'}} ></i>
                        </div> */}
                    </div>
                    <div className="gradient-flex" >
                        <div className="d-flex flex-column row-12 chart-container">
                            <h5 className="mb-0 chart-header font-weight-bold py-3 text-dark" id="target1">{this.state.competency_title}</h5>
                            <div className="d-flex flex-column bg bg-white chart-body mx-4">
                                <div className="d-flex flex-row py-2 pl-3 pr-4 " style={{ height: 80 }} >
                                    <div className="d-flex flex-column w-100">
                                        <div style={{ flex: 0.25, height: 20 }} className="d-flex flex-row">
                                            {
                                                arr.map((obj, key) => {
                                                    return (
                                                        <div key={key} className="bottom-less-border  p-2 w-100">
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                        <div style={{ flex: 0.4, position: 'relative', height: 30 }} className="d-flex flex-row">
                                            <div style={{ width: `${this.state.competency_avg_percent}%`, }} className="d-flex align-items-center justify-content-end overflow-flex px-1">
                                                <p style={{ fontSize: 10 }} className="mb-0 ">
                                                    {this.state.competency_avg != null ? this.state.competency_avg.toFixed(2): ''}
                                                </p>
                                                <p style={{ fontSize: 12 }} className="mb-0 px-1">{this.state.currentLevelName}</p>
                                            </div>
                                            {
                                                arr.map((obj, key) => {
                                                    return (
                                                        <div key={key} className="y-less-border p-2 w-100">
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                        <div style={{ flex: 0.25, height: 20 }} className="d-flex flex-row">
                                            {
                                                arr.map((obj, key) => {
                                                    return (
                                                        <div key={key} className="top-less-border p-2 w-100">
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                        <div style={{ flex: 0.1, height: 10 }} className="d-flex flex-row">
                                            {
                                                arr.map((obj, key) => {
                                                    return (
                                                        <div key={key} style={{ background: `${obj.color}` }} className="top-less-border p-1 w-100">
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex flex-row w-100 pl-3 pr-2" style={{ height: 20 }} >
                                    {
                                        arr.map((obj, key) => {
                                            if (key == 9) {
                                                return (
                                                    <React.Fragment>
                                                        <p style={{ fontSize: 10 }} className="mb-0 w-100 text-left">{key}0%</p>
                                                        <p style={{ fontSize: 10 }} className="mb-0 w-100 text-left">100%</p>
                                                    </React.Fragment>
                                                )
                                            }
                                            else {
                                                return (
                                                    <p style={{ fontSize: 10 }} className="mb-0 w-100 text-left">{key}0%</p>
                                                )
                                            }
                                        })
                                    }
                                </div>
                            </div>
                            
                            {
                                view_detailed_comparison === false &&
                                <div className="text-center m-2">
                                    <button type="button" className="btn text-white py-1 px-3 h6" onClick={() => this.setState({ modularToolTip: !this.state.modularToolTip })} style={{background: '#404040'}}>
                                        View individual competency scores
                                    </button>
                                    {
                                        this.state.modularToolTip ?
                                            <ModularTooltip customWidthClass="w-400 overflow-height-average-scores" modalHeader={true} toggleValue={this.state.modularToolTip} id={"target1"} customComponent={this.renderCustomComponent()} callbackPopover={this.callBack} placement="bottom" title="Average Scores" /> :
                                            null
                                    }
                                </div>
                            }
    
                        </div>
                        <div className="col-12 my-3">
                            
                            {
                                this.state.dynamicTableImprovementAreas.length ?
                                    this.state.dynamicTableImprovementAreas.map((rows, key) => {
                                        const attrName = rows.area.length ? rows.area[0].child_content.length ? rows.area[0].child_content[0] ? rows.area[0].child_content[0].attribute_name : 'null' : 'null' : 'null'
                                        const review_question_text = rows.area.length ? rows.area[0].child_content.length ? rows.area[0].child_content[0] ? rows.area[0].child_content[0].review_question_text : null : null : null
                                        console.log('dynamicTableImprovementAreas', rows)
                                        return (
                                            <div className="d-flex flex-row justify-content-center  col-12 px-5">
                                                <DynamicGradientTables key={rows.area} classNameProps={key ? this.state.class_name_2 : this.state.class_name} data={rows.area} onClick={(child_header_imp,header_text_imp) => this.openModularToolTipForImprovementIdeas(child_header_imp, header_text_imp)} />
                                                {
                                                    attrName === 'null' ?
                                                        <div id={`TooltipExample${attrName}`}></div>
                                                    :
                                                        null
                                                }
                                                {
                                                    this.state.openImprovementTooltip && this.state.ImprovementTooltip.childContent === attrName ?
                                                        <ModularTooltip modalHeader={true} popoverOpen={this.state.openImprovementTooltip} toggleValue={this.state.openImprovementTooltip} id={`TooltipExample${attrName}`} customComponent={this.popUpImprovement(review_question_text)} callbackPopover={() => this.openModularToolTipForImprovementIdeas(this.state.ImprovementTooltip["childContent"], this.state.ImprovementTooltip["headerText"])} placement="bottom" title={`Impact on ${attrName}`} />
                                                    :
                                                        null
                                                }
                                                <DynamicGradientTables key={rows.comp} classNameProps={key ? this.state.class_name1_2 : this.state.class_name1} data={rows.comp} />
                                            </div>
                                        )
                                    })
                                :
                                    null
                            }
                        </div>
                        {this.routableSelects()}
                    </div>
                </React.Fragment>
            )
        }
        else {
            return (
                <React.Fragment key={this.state.competency_length}>
                    <div className="d-flex justify-content-around drop-down-container mb-3 mt-5">
                        {/* <div className="d-flex">
                        </div>
                        <div className="d-flex justify-content-center">
                            <h6 className="d-flex justify-content-end align-items-center mb-0 px-2 ">Select Competency/Metric/Value</h6>
                            <select
                             style={{width: 60}}
                                className="drop-down"
                                onChange={(e) => this.competencyValueDropDownOnChange(e)}
                            >
                                <option value={this.state.competency_title} disabled selected></option>
                                {
                                    dataFormater(this.props,this.state.competency_all_data,'competency_data_each',this.state.checkboxData).map(competencyData => {
                                        return <option value={competencyData.competency_id} >{competencyData.competency_title}</option>
                                    })
                                }
                            </select>
                        </div> */}
                        {/* <Button className="d-flex" style={{cursor: 'pointer', background: 'transparent' }} onClick={() => this.selectMultipleButtonAction()}>
                            <img className="compLogo" src={compLogo} width={100} alt="competency logo" />
                        </Button> */}
                        {/* <div className="d-flex" style={{cursor: 'pointer'}} onClick={() => this.selectMultipleButtonAction()}>
                            <p className="mb-0 p-1 font-weight-bold">Select Multiple</p>
                            <i className="fas fa-arrow-right mb-0 pt-2 " ></i>
                        </div> */}
                    </div>
                    <div className="gradient-flex" >
                        <div className="d-flex flex-column row-12 chart-container">
                            <h5 className="mb-0 chart-header font-weight-bold py-3 text-dark">{this.state.competency_title}</h5>
                            <div className="d-flex flex-column bg bg-white chart-body mx-4">
                                <div className="d-flex flex-row py-2 pl-3 pr-4 " style={{ height: 80 }} >
                                    <div className="d-flex flex-column w-100">
                                        <div style={{ flex: 0.25, height: 20 }} className="d-flex flex-row">
                                            {
                                                arr.map((obj, key) => {
                                                    return (
                                                        <div key={key} className="bottom-less-border  p-2 w-100">
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                        <div style={{ flex: 0.4, position: 'relative', height: 30 }} className="d-flex flex-row">
                                            <div style={{ width: `${this.state.competency_avg_percent}%`, }} className="d-flex align-items-center justify-content-end overflow-flex px-1">
                                                <p style={{ fontSize: 10 }} className="mb-0 ">{this.state.competency_avg != null ? this.state.competency_avg.toFixed(2): ''}</p>
                                                <p style={{ fontSize: 12 }} className="mb-0 px-1">{this.state.currentLevelName}</p>
                                            </div>
                                            {
                                                arr.map((obj, key) => {
                                                    return (
                                                        <div key={key} className="y-less-border p-2 w-100">
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                        <div style={{ flex: 0.25, height: 20 }} className="d-flex flex-row">
                                            {
                                                arr.map((obj, key) => {
                                                    return (
                                                        <div key={key} className="top-less-border p-2 w-100">
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                        <div style={{ flex: 0.1, height: 10 }} className="d-flex flex-row">
                                            {
                                                arr.map((obj, key) => {
                                                    return (
                                                        <div key={key} style={{ background: `${obj.color}` }} className="top-less-border p-1 w-100">
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex flex-row w-100 pl-3 pr-2" style={{ height: 20 }} >
                                    {
                                        arr.map((obj, key) => {
                                            if (key == 9) {
                                                return (
                                                    <React.Fragment>
                                                        <p style={{ fontSize: 10 }} className="mb-0 w-100 text-left">{key}0%</p>
                                                        <p style={{ fontSize: 10 }} className="mb-0 w-100 text-left">100%</p>
                                                    </React.Fragment>
                                                )
                                            }
                                            else {
                                                return (
                                                    <p style={{ fontSize: 10 }} className="mb-0 w-100 text-left">{key}0%</p>
                                                )
                                            }
                                        })
                                    }
                                </div>
                            </div>
                            <div className="p-3"></div>
                            {
                                // view_detailed_comparison === false &&
                                // <div className="text-center m-2">
                                //     <button type="button" className="btn text-white py-1 px-3 h6" onClick={() => this.setState({ view_detailed_comparison: true })}  style={{background: '#404040'}}>
                                //         View individual competency scores
                                //     </button>
                                // </div>
                            }
    
                        </div>
                        <h6 className="mb-0 my-1 text-left ml-4 pt-3 font-weight-bold">Individual Competency Rating</h6>
                        <div className="d-flex flex-row justify-content-center col-12 px-0">
                            <div className="col-8 px-0">
                                <CompetencyGraph
                                    data={this.state.competencyData}
                                    Tooltip={this.state.Tooltip}
                                    selected_route_parameter={this.state.selected_route_parameter}
                                    onActionInvoked={(key, val) => {
                                        this.setState({
                                            currentCategoryOnRoute: 0
                                        }, () => {
                                            this.onActionInvoked(key, val)
                                        })
                                    }}
                                    tableHeadingColor="linear-gradient(to right, #6200FF , #3F00A2)"
                                    barColor="rgb(22, 43, 162)"
                                    rowHighlightColor="#E4D342"
                                    highlightTextColor="black"
                                    textSmall={true}
                                />
                            </div>
                            {this.renderAlluserAvg()}
                        </div>
                        {this.routableSelects()}
                    </div>
                </React.Fragment>
            )
        }
        
    }


    onClickCheckboxAll = (e) => {
        let checkboxData = this.state.checkboxData;
        let tableCount = 0;
        for (let i = 0; i < checkboxData.length; i++) {
            if (e.target.value === checkboxData[i].heading) {
                for (let j = 0; j < checkboxData[i].data.length; j++) {
                    checkboxData[i].data[j].isChecked = e.target.checked
                    if (e.target.checked === true) {
                        checkboxData[i].count = checkboxData[i].data.length
                    }
                    if (e.target.checked === false) {
                        checkboxData[i].count = 0
                    }
                }
            }
            if (checkboxData[i].count > 0) {
                tableCount = tableCount + 1;
            }
        }

        for (let i = 0; i < checkboxData.length; i++) {
            if (checkboxData[i].count == 0 && tableCount > 0) {
                checkboxData[i].disabled = true
            }
            if (tableCount === 0) {
                checkboxData[i].disabled = false
            }
        }
        
        this.setState({ checkboxData: checkboxData, checkboxDataLoader: false })
    }

    renderFilter() {

        let noDataForCompetency = false

        let counterData = 0
        this.state.checkboxData.map(checkboxes => {
            if(checkboxes.data.length) {
                counterData++
            }
        })

        if(counterData === 0) {
            noDataForCompetency = true
        }
        
        return (
            <React.Fragment>
                    {
                        noDataForCompetency ?
                            <p className="pt-5 text-center">No Values / Competencies defined for your Organisation</p>
                        :
                            <h6 className="pt-5 text-center font-weight-bold">Select one or more competencies/values to see
                            team and individual scores and improvement areas</h6>
                    }
                <div className="d-flex flex-row justify-content-around align-items-start">
                    {
                        !noDataForCompetency ?
                            this.state.checkboxData.map((obj, key) => {
                                return (
                                    <React.Fragment>
                                        <div className="d-flex flex-column">
                                            <div className="d-flex flex-row align-items-center align-self-center mx-0">
                                                <div className="p-2 rounded-top" style={{ background: `${obj.disabled === true ? `#F0F0F0` : `linear-gradient(to right, #9d9844, #cbc456)`}`, width: 250, color: '#ffffff' }}>
                                                    <h6 className="mb-0 text-center font-weight-bold
                                                    ">{obj.heading}</h6>
                                                </div>
                                            </div>
                                            <div key={key} className={`filter border ${obj.disabled ? '' : 'border-secondary'} rounded-bottom`} style={{ minHeight: '250px', maxHeight: '250px', overflowY: 'scroll', width: 250 }}>
                                                <Collapse
                                                    isOpen={true}
                                                >
                                                    {
                                                        obj.data.length == 0 ?
                                                            <div style={{ height: 10 }}>
                                                                <p className="font-weight-bold">No {obj.heading} found!</p>
                                                            </div> :
                                                            <React.Fragment>
                                                                <div>
                                                                    <div className="d-flex flex-row px-3 py-2 align-items-center" style={{fontSize: 14, backgroundColor: obj.disabled ? '#f0f0f000' : '#676767', color: '#fff'}}>
                                                                        <input disabled={obj.disabled} type="checkbox" style={{ cursor: "pointer" }} value={obj.heading} checked={obj.data.map(individualData => individualData.isChecked ? 1 : 0).reduce((total, acc) => total + acc) === obj.data.length} onChange={(e) => this.onClickCheckboxAll(e)} id={`_selectall${obj.heading}`} />
                                                                        <label for={`_selectall${obj.heading}`} className={`px-2 mb-0 cursor-pointer text-left ${obj.disabled === true ? `text-muted` : ``}`}  >
                                                                            Select all {obj.heading === 'Competency' ? 'Competencie' : obj.heading}s
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                {
                                                                    obj.data.map(
                                                                        (data, j) => {
                                                                            return (
                                                                                < div key={j} className="d-flex flex-row pt-2 px-3 align-items-center" style={{fontSize: 14}}>
                                                                                        <input disabled={obj.disabled} type="checkbox" style={{ cursor: "pointer" }} name={data.name} value={data.name} checked={data.isChecked} onChange={(e) => this.onClickCheckbox(e, data.id, obj.name)} id={`_${data.id}${obj.name}`} />
                                                                                        <label for={`_${data.id}${obj.name}`} className={`px-2 mb-0 cursor-pointer text-left ${obj.disabled === true ? `text-muted` : ``}`}  >
                                                                                            {data.name}
                                                                                        </label>
                                                                                </div>
                                                                            )
                                                                        }
                                                                    )
                                                                }
                                                            </React.Fragment>
                                                    }
                                                </Collapse>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                )
                            })
                        :
                            null
                    }
                </div>
                {
                    this.renderApplyFilterButton()
                }
            </React.Fragment>
        )
    }

    doSomthing = (data) => {
        this.setState({filterData : data}, () => {
            this.props.dispatch(analyseActions.saveAssessorGroups(this.state.filterData))            
        })
    }

    render() {
        const { saveAssesorGroupListResponse, competencyListError, getAnalyticsMetricListLoading } = this.props;
        const { navData, select_data, view_detailed_comparison } = this.state

        return (
            <div>
                <Navbar navItems={navData} backgroundColor="dark" />
                <div className="container-post-nav">
                    <SideNavBar
                        analyzeFilterData={this.state.filterData}
                        isAnalyse = {true}
                        organisationName={localStorage.getItem('orgName')}
                        orgId={this.props.match.params.id}
                        teamId={localStorage.getItem('teamId')}
                        teamName={localStorage.getItem('teamName')}
                        callBack={this.doSomthing.bind(this)}
                    // onChangeTeam={(data) => this.onChangeTeam(data)}
                    />
                    <div className="analyz-container">
                        <AnalysisNavBar clearData={() => {
                            this.selectHomeRoutes()
                        }} analyticsData={this.props.saveModulePermissionsResponse} orgId={this.props.match.params.id} analyticsType={'people'} />
                        {
                            this.props.singleValidatorResponse ?
                            <p className="text-center">
                                    Team Members should be more than 2
                            </p>:
                            <div className="swot-container-sub ">
                                {
                                    typeof this.props.saveAssesorIdsResponse !== 'string' ?
                                        this.props.saveAssesorIdsResponse.assessmentIds.length && this.props.saveAssesorIdsResponse.assessorIds.length ?
                                            <div>
                                                {
                                                    this.state.mode == 'filter_non' ?
                                                        (!getAnalyticsMetricListLoading && !competencyListError) && !this.state.checkboxDataLoader ?
                                                            this.renderFilter()
                                                        :
                                                            this.state.checkboxDataLoader ?
                                                                <p className="text-center mt-4">
                                                                    <i className="fas fa-spinner fa-spin " ></i>
                                                                    &nbsp;loading
                                                                </p>
                                                            :
                                                                null

                                                    :
                                                    <React.Fragment>
                                                        {
                                                            (!this.props.getCompetencyLoading && !this.props.competencyError) && this.state.competency_length.length !== 0 ?
                                                                this.renderPostFilter()
                                                        :
                                                            this.props.competencyError ?
                                                                <p className="text-center mt-4">
                                                                    {this.props.competencyErrorResponse}
                                                                </p> 
                                                            :
                                                                <p className="text-center mt-4">
                                                                    <i className="fas fa-spinner fa-spin " ></i>
                                                                    &nbsp;loading
                                                                </p> 
                                                        }
                                                        {/* {
                                                            this.state.competency_length.length == 0 ?
                                                                <p className="text-center mt-4">
                                                                    <i className="fas fa-spinner fa-spin " ></i>
                                                                    &nbsp;loading
                                                                </p> 
                                                            :
                                                                (!this.props.getCompetencyLoading && !this.props.competencyError) ?
                                                                    this.renderPostFilter()
                                                                :
                                                                    this.props.competencyError ?
                                                                        <p className="text-center mt-4">
                                                                            {this.props.competencyErrorResponse}
                                                                        </p> 
                                                                    :
                                                                        <p className="text-center mt-4">
                                                                            <i className="fas fa-spinner fa-spin " ></i>
                                                                            &nbsp;loading
                                                                        </p> 
                                                        } */}
                                                    </React.Fragment>
                                                }
                                            </div>
                                        :
                                            <div className="d-flex justify-content-center drop-down-container m-3">
                                                <p>{this.props.saveAssesorIdsResponse.assessmentIds.length === 0 ? 'No Team Members Available!' : 'No Relations Available!'}</p>
                                            </div>
                                    :
                                        null
                                }
                                {/* Swot container */}
                            </div>
                        }
                        {/* <div className="yellowCircle"></div> */}
                    </div>
                    {/* anaLyze container div */}
                </ div>
            </div>


        );
    }
}

function mapStateToProps(state) {
    const saveModulePermissionsResponse = state.saveModulePermissionsReducer.data;

    const { getModulePermissionsLoading } = state.getModulePermissionsListReducer;
    const getModulePermissionsListError = state.getModulePermissionsListReducer.error;
    const getModulePermissionsListResponse = (!getModulePermissionsLoading && !getModulePermissionsListError) ? state.getModulePermissionsListReducer.data.data.message : '';

    const saveTeamDetailsResponse = state.saveTeamDetailsReducer.data;

    const { getPaUserPermissionListLoading } = state.getPaUserPermissionListReducer;
    const getPaUserPermissionListError = state.getPaUserPermissionListReducer.error;
    const getPaUserPermissionListResponse = (!getPaUserPermissionListLoading && !getPaUserPermissionListError) ? state.getPaUserPermissionListReducer.data.data.message : '';

    const { assessorGroupsLoading } = state.assessorGroupsReducer;
    const assessorGroupsError = state.assessorGroupsReducer.error;
    const assessorGroupsResponse = (!assessorGroupsLoading && !assessorGroupsError) ? state.assessorGroupsReducer.data.data : '';

    //Competency List
    const { getAnalyticsMetricListLoading } = state.getAnalyticsMetricListReducer
    const competencyListError = state.getAnalyticsMetricListReducer.error
    const competencyListDataResonse = (!getAnalyticsMetricListLoading && !competencyListError) ?  state.getAnalyticsMetricListReducer.data : '';



    //Competency Data
    const { getCompetencyLoading } = state.competencyReducer
    const competencyError = state.competencyReducer.error
    const competencyErrorResponse = state.competencyReducer.errorResponse
    const competencyDataResonse = (!getCompetencyLoading && !competencyError) ?  state.competencyReducer.data : '';

    //Header Permission
    const { headPerLoading } = state.headerPermissionReducer
    const headPerLoadingError = state.headerPermissionReducer.error
    const headPerLoadingResonse = (!headPerLoading && !headPerLoadingError) ?  state.headerPermissionReducer.data : '';

    const saveAssesorGroupListResponse = state.saveAssesorGroupListReducer.data;
    const saveAssesorIdsResponse = state.saveAssesorIdsReducer.data;


    const singleValidatorResponse = state.singleValidatorReducer.data;
    

    return {
        saveModulePermissionsResponse,
        getModulePermissionsListResponse,
        saveTeamDetailsResponse,
        getPaUserPermissionListResponse,
        assessorGroupsResponse,
        saveAssesorGroupListResponse,
        saveAssesorIdsResponse,
        competencyListDataResonse,
        competencyListError,
        getAnalyticsMetricListLoading,
        getCompetencyLoading,
        competencyError,
        competencyErrorResponse,
        competencyDataResonse,
        headPerLoadingResonse,
        headPerLoading,
        headPerLoadingError,
        
        singleValidatorResponse
    }
}

export default connect(mapStateToProps)(Competency)



// WEBPACK FOOTER //
// ./src/_pages/Organzation/Analyze/Category/Competency/index.js